import type { IconName } from '../iconMeta'

import { GLYPHS } from './glyphs'
import type { GlyphData } from './glyphs'

/**
 * Lazy-loaded map of every curated icon name to its glyph geometry.
 *
 * Kept in a dedicated module so it loads as a lazy chunk: the picker
 * dynamically imports this map only when opened, keeping the eager bundle small.
 * The `satisfies Record<IconName, GlyphData>` constraint on `GLYPHS` guarantees
 * this map stays exhaustively in sync with `ICON_META`.
 */
export const ICONS: Record<IconName, GlyphData> = GLYPHS

/** Map of every curated icon name to its glyph geometry. */
export type IconsModule = typeof ICONS

export type { GlyphData }
